export default {
	main: '#9D1915',
	secondary: '#FE6600',
	gradientModal: 'linear-gradient(181deg, #931613 0%, #380200 100%)',
	gradientCard: 'linear-gradient(0deg,#9D1915 0%, #380200 100%)',	
}
